/**
 * Styles for wf-other component (Shadow DOM)
 *
 * Co-located with the component for better maintainability.
 */

import { css } from 'lit';

export const wfOtherStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .wf-other-container {
    margin-top: var(--wf-spacing-4);
  }

  .wf-other-label {
    display: block;
    margin-bottom: var(--wf-spacing-2);
    font-size: var(--wf-font-size-sm);
    font-weight: var(--wf-font-weight-label);
    color: var(--wf-color-text);
  }

  .wf-other-label span {
    font-weight: var(--wf-font-weight-input);
    color: var(--wf-color-text-muted);
  }

  .wf-other-input-wrapper {
    display: flex;
    align-items: center;
    gap: var(--wf-spacing-3);
    height: var(--wf-input-min-height);
    background: var(--wf-glass-bg);
    backdrop-filter: blur(var(--wf-glass-blur));
    -webkit-backdrop-filter: blur(var(--wf-glass-blur));
    border: 1px solid var(--wf-glass-border);
    border-radius: var(--wf-radius-md);
    box-shadow: var(--wf-glass-shadow);
    padding-left: var(--wf-spacing-3);
    padding-right: var(--wf-spacing-2);
    transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
  }

  .wf-other-input-wrapper:focus-within {
    border-color: var(--wf-color-primary);
    box-shadow: 0 0 0 var(--wf-focus-ring-width) var(--wf-focus-ring-primary);
  }

  .wf-other-input {
    flex: 1;
    min-height: calc(var(--wf-input-min-height) - 2px);
    padding: var(--wf-spacing-3);
    padding-left: 0;
    font-size: var(--wf-font-size-base);
    font-weight: var(--wf-font-weight-input);
    color: var(--wf-color-text);
    background: transparent;
    border: none;
    outline: none;
    box-sizing: border-box;
  }

  .wf-other-input::placeholder {
    color: var(--wf-color-text-muted);
    font-weight: var(--wf-font-weight-input);
  }

  .wf-other-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease, visibility 200ms ease;
  }

  /* Show button when input has value */
  .wf-other-input-wrapper.has-value .wf-other-actions {
    opacity: 1;
    visibility: visible;
  }

  /* Button inside input box should not stretch */
  .wf-other-actions ::slotted(*) {
    width: auto;
  }
`;
